import { Center, Flex, Icon, Switch, Tooltip } from '@chakra-ui/react';
import { KFormLabel } from '@/ui-library/components';
import { InfoCircle } from '@kula-ai/icons/dual-tone/InfoCircle';

export const SwitchField = ({ item, field }) => {
  if (!item) return null;
  const {
    name,
    isEditable = true,
    label,
    style,
    subLabel,
    subLabelStyles,
    labelStyles,
    labelInfoText,
  } = item;

  const defaultStyles = {
    borderRadius: '8px',
  };

  return (
    <>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        style={{ ...defaultStyles, ...style }}
      >
        <Flex flexDir="column">
          <Flex>
            {label && (
              <KFormLabel
                htmlFor={name}
                style={{
                  ...labelStyles,
                }}
              >
                {label}
              </KFormLabel>
            )}
            {labelInfoText && (
              <Tooltip variant="default" label={labelInfoText}>
                <Center ml="6px" w="18px" h="18px">
                  <Icon
                    as={InfoCircle}
                    w="16px"
                    h="16px"
                    color="secondary-700"
                  />
                </Center>
              </Tooltip>
            )}
          </Flex>
          {subLabel && (
            <KFormLabel
              htmlFor={name}
              style={{ ...subLabelStyles }}
              requiredIndicator={null}
              variant="subLabel"
            >
              {subLabel}
            </KFormLabel>
          )}
        </Flex>
        <Switch
          className={`ats-switch-toogle ${field?.value ? 'active' : ''}`}
          colorScheme="ats-primary"
          {...field}
          id={name}
          isChecked={field?.value || false}
          isDisabled={!isEditable}
        />
      </Flex>
    </>
  );
};
